import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element, elements } from '@shared/easyfy.core';
import { addCss } from '@shared/easyfy.utils';

import filter from '@webModules/filter';
import ToggleCss from '@shared/easyfy.togglecss';

namespace Easyfy.Web.Pages {
  @invoke
  class Brand {
    static Instance: Brand;

    private togglecss: ToggleCss;

    constructor() {
      Brand.Instance = this;
      this.togglecss = new ToggleCss('togglecss');
    }

    onInit() {
      new filter.Filter(
        filter.FilterFor.Brand,
        '[data-container="filter"]',
        '[data-container="paging"]',
        '[data-container="filterable-products"]',
        '[data-container="sorter"]'
      );
      document.addEventListener(
        'filter.totalHitsUpdated',
        Brand.updateTotalHits
      );

      globalEvent({
        type: 'click',
        event: {
          action: 'open-filter-and-sort',
          callback: Brand.openFilterAndSort
        }
      });
    }

    static updateTotalHits = (event) => {
      const totalHitsElements = elements('.hits-result');
      if (totalHitsElements && totalHitsElements.length > 0) {
        totalHitsElements.forEach((item) => {
          item.innerHTML = event.detail.totalHits;
        });
      }
    };

    static openFilterAndSort = (event) => {
      const filterElement = element('[data-container="filter"]') as HTMLElement;
      filterElement?.classList.add('display');

      const select = filterElement.querySelector(
        '[data-container="custom-select"]'
      ) as HTMLElement;
      if (select) addCss(select, 'open');
    };
  }
}

export default Easyfy.Web.Pages;
